import { render } from "./Subprogram.vue?vue&type=template&id=21e02dad"
import script from "./Subprogram.vue?vue&type=script&lang=js"
export * from "./Subprogram.vue?vue&type=script&lang=js"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__